// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */@media (min-width:768px){.block-cards-list .card-col:not(:first-child) .card[data-v-7c274c8b]{border-left:none}}@media (max-width:767px){.block-cards-list .card-col:not(:last-child) .card[data-v-7c274c8b]{border-bottom:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
